const skillsBack = [
  { type: 'Python', level: 85 },
  { type: 'Java Core', level: 85 },
  { type: 'Java EE', level: 80 },
  { type: 'OOP', level: 80 },
  { type: 'SQL', level: 75 },
  { type: 'Spring', level: 70 }
];

export default skillsBack;
